import { useState } from 'react';
import { Button } from '../Button/Button.tsx';

/** An identifier with a Copy button and a status message (BB-17). */
export function CopyId({ value, label }: { value: string; label: string }) {
  const [copied, setCopied] = useState<'idle' | 'copied' | 'failed'>('idle');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied('copied');
    } catch {
      setCopied('failed');
    }
  };
  return (
    <span className="bb-copy-id">
      <code>{value}</code>
      <Button size="sm" onClick={() => void copy()} aria-label={`Copy ${label}`}>
        Copy
      </Button>
      {copied !== 'idle' && (
        <span role="status" className="bb-field__hint">
          {copied === 'copied' ? 'Copied' : 'Copy failed — select the text instead'}
        </span>
      )}
    </span>
  );
}
